export default (scope) => {
  return (...args) => {
    console.debug(`${scope}:`, ...args);
  };
};
